import React from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from 'buyside/components/presentation/Accordion/accordionComponents';
import CardFeed from 'buyside/components/presentation/CardFeed/cardFeed';
import EntityBuysideConsensus from 'buyside/components/presentation/CompanyShowPage/entityBuysideConsensus';
import EntityFeed from 'buyside/components/presentation/CompanyShowPage/entityFeed';
import EntityOverview from 'buyside/components/presentation/CompanyShowPage/entityOverview';
import EntityPost from 'buyside/components/presentation/CompanyShowPage/entityPost';
import EntityRelatedCompanies from 'buyside/components/presentation/CompanyShowPage/entityRelatedCompanies';
import EntityStats from 'buyside/components/presentation/CompanyShowPage/entityStats';
import EntityCryptoStats from 'buyside/components/presentation/CompanyShowPage/entityCryptoStats';
import { EntityShowJoyrideTarget } from 'buyside/components/presentation/Joyride/EntityShowJoyride/entityShowJoyrideHelper';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

import styles from 'buyside/components/presentation/CompanyShowPage/companyShowPageStyles.scss';

const EntityShowPage: React.FC<{ id: string; isPublic: boolean; isCrypto: boolean }> = ({
  id,
  isPublic,
  isCrypto
}): React.ReactElement => {
  return (
    <div className={styles.entityShowContainer}>
      <div className={styles.entityShowLeft}>
        <CardFeed>
          <EntityOverview id={id} isPublic={isPublic} />
        </CardFeed>
        <Accordion initialOpen={window.innerWidth > 1024}>
          <AccordionTitle collapseIcon={faAngleUp} expandable expandIcon={faAngleDown}>
            Statistics
          </AccordionTitle>
          <AccordionContent>
            <ErrorBoundary pageName="entity stats">
              {isCrypto ? <EntityCryptoStats id={id} /> : <EntityStats id={id} />}
            </ErrorBoundary>
          </AccordionContent>
        </Accordion>
      </div>
      <div className={styles.entityShowRight}>
        {!isPublic && (
          <Accordion initialOpen={window.innerWidth > 1024}>
            <AccordionTitle collapseIcon={faAngleUp} expandable expandIcon={faAngleDown}>
              Buyside Consensus Poll
            </AccordionTitle>
            <AccordionContent>
              <ErrorBoundary pageName="entity buyside consensus">
                <div data-joyride-target={EntityShowJoyrideTarget.BUYSIDE_CONSENSUS}>
                  <EntityBuysideConsensus id={id} />
                </div>
              </ErrorBoundary>
            </AccordionContent>
          </Accordion>
        )}
        <div className={styles.entityShowRightBottom}>
          <div className={styles.entityShowRightCenter}>
            {!isPublic && (
              <ErrorBoundary pageName="entity post">
                <EntityPost id={id} />
              </ErrorBoundary>
            )}
            <ErrorBoundary pageName="entity feed">
              <EntityFeed id={id} isPublic={isPublic} />
            </ErrorBoundary>
          </div>
          <div className={styles.entityShowRightRight}>
            <Accordion initialOpen={window.innerWidth > 1024}>
              <AccordionTitle collapseIcon={faAngleUp} expandable expandIcon={faAngleDown}>
                Related Companies
              </AccordionTitle>
              <AccordionContent>
                <ErrorBoundary pageName="entity related companies">
                  <EntityRelatedCompanies id={id} isPublic={isPublic} />
                </ErrorBoundary>
              </AccordionContent>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityShowPage;
